import {ApiContactKind} from '@/model/ContactKind';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';
import {ApiSortOrder} from '../meta/odata';


export enum ResourceKontaktArt {
  KontaktArt = '/Kontaktart',
}

export async function getContactKinds(): Promise<CombinedApiResponse<ApiContactKind[]>> {
  const response = await doApiRequest<ApiContactKind[]>({
    method: Method.Get,
    resource: ResourceKontaktArt.KontaktArt,
    module: Module.Stammdaten,
    useCache: true,
    select: new Set([
      'Kurz', 'Bezeichnung',
    ]),
    sorts: [['Bezeichnung', ApiSortOrder.Asc]],
  });

  return [response.Data, response.CountAll];
}

